import * as R from 'ramda'

/**
 * This removes required keys from filterData.
 * Unrequired keys are basically the ones that are not required by BE for performing the filtration.
 * @param filterData
 * @returns {*|(function(*=): (*))}
 */
export default filterData => {
  return R.omit(['list'], filterData)
}
